require('./bootstrap');

import ChivaMap from './components/ChivaMap';

const app = Vue.createApp({
    data() {
        return {
            counter: 0
        }
    },

    mounted() {
        // require('./scripts/scripts');
    }
});

app.component("chiva-map", ChivaMap);
app.mount('#app');

window.alertMessage = function (type, message) {
    let PNotifyOptions = {
        title: 'TITLE',
        text: message
    }

    switch (type) {
        case 'error':
            PNotifyOptions.title = 'ERROR';
            PNotifyOptions.type = 'error';
            break;
        case 'info':
            PNotifyOptions.title = 'INFO';
            PNotifyOptions.type = 'info';
            break;
        case 'success':
            PNotifyOptions.title = 'SUCCESS';
            PNotifyOptions.type = 'success';
            break;
    }

    PNotify.alert(PNotifyOptions);
}

window.alertMessageBanner = function (type, message) {
    if (typeof window.stackBarTop === 'undefined') {
        console.log("window.stackBarTop undefined");
        window.stackBarTop = new PNotify.Stack({
            modal: false,
            dir1: 'down',
            firstpos1: 0,
            spacing1: 0,
            push: 'top',
            maxOpen: Infinity
        });
    }

    const opts = {
        title: 'Over Here',
        text: message,
        addClass: 'stack-bar-top',
        shadow: false,
        width: '100%',
        stack: window.stackBarTop,
        styling: 'material',
        mode: 'light',
        icons: 'material'
    };

    switch (type) {
        case 'error':
            opts.title = 'ERROR';
            opts.type = 'error';
            break;
        case 'info':
            opts.title = 'INFO';
            opts.type = 'info';
            break;
        case 'success':
            opts.title = 'SUCCESS';
            opts.type = 'success';
            break;
    }
    PNotify.alert(opts);
}

$(document).ready(function() {
    $('.select-2').select2({
        theme: "bootstrap"
    });
});
